import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';

import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useTransactionCodes() {
  const source = axios.CancelToken.source();

  const [transactionCodes, setTransactionCodes] = useState<vp.TransactionCode[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchTransactionCodes = async () => {
    try {
      setLoading(true);
      const res = await api.fetchTransactionCodes(source);

      setTransactionCodes(res.TransactionCodes);
      return res;
    } finally {
      setLoading(false);
    }
  };
  const reset = () => {
    setTransactionCodes([]);
  };

  return {
    loading,
    transactionCodes,
    fetchTransactionCodes,
    reset,
  };
}
